<template>
  <div>
    <!-- 轮播图 -->
    <swiper title="企业管理App" :bannerList="bannerList"></swiper>

    <!-- 项目背景 -->
    <section class="d-flex align-items-center pt-4 pb-4 text-line-height-1" data-aos="fade-up">
      <div class="container">
        <main-title title="项目背景"></main-title>
        <retract-list :dataList="projectList"></retract-list>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <layout-list :dataList="describeList1"></layout-list>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <layout-list :dataList="describeList2"></layout-list>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <layout-list :dataList="describeList3"></layout-list>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <layout-list :dataList="describeList4"></layout-list>
      </div>
    </section>

    <section class="d-flex align-items-center pt-4 pb-4" data-aos="fade-up">
      <div class="container">
        <layout-list :dataList="describeList5"></layout-list>
        <img src="@/assets/img/common/secure/describe6.png" class="image-width-100 pt-4 pb-4" />
      </div>
    </section>
  </div>
</template>

<script>
import Swiper from '@/components/Swiper.vue'
import LayoutList from '@/components/LayoutList'
export default {
  name: 'Secure',
  components: { Swiper, LayoutList },
  props: {},
  data() {
    return {
      bannerList: [{ src: require('@/assets/img/common/caseList/secure/banner1.png') }, { src: require('@/assets/img/common/caseList/secure/banner2.png') }],
      // 项目概述
      projectList: [
      '某宝集团母公司－某宝科技，30多年来除了致力于光电零组件，更持续拓展电脑与数位家庭、消费性电子、通讯产品、关键零组件与次系统、并逐步跨足车用电子等4C领域，在市场上具有举足轻重的地位；此外，亦具备优异的研发设计能力，藉由全面性的产品服务，提供客户一次购足的选择，并且成为国际大厂ODM/OEM合作供应商首选。'
      ],
      describeList1: [
        {
          type: 'text',
          title: '企业级APP助力新冠防控',
          col: 7,
          content: [
            '自疫情爆发以来，积极配合政府严格执行各项防疫政策，及时跟踪员工的健康状况。把员工进厂、工作区域、就餐位置、离厂等各环节都纳入了防疫管理范围。',
            '为及时跟踪员工的健康状况及厂区活动轨迹，采用新冠防疫App的方式将核酸码、抗原检测、就餐位置、出入位置等多种风险因素进行整合，形成一人一码的精准防控管理方案，大大提高了厂区的防疫管理效率。',
          ],
        },
        {
          type: 'image',
          src: require('@/assets/img/common/secure/describe1.png'),
          col: 5,
        },
      ],
      describeList2: [
        {
          type: 'image',
          src: require('@/assets/img/common/secure/describe2.png'),
          col: 5,
        },
        {
          type: 'text',
          title: '企业管理App',
          col: 7,
          content: [
            '企业管理App为员工提供各项服务，如员工个人考勤、 OA、班车查询、体检安排、员工满意度调查、食堂菜谱、宿舍登记等。',
            '企业管理App还提供可靠的公告系统，用于向员工发送企业内部的信息。公告系统还提供水印和安全功能以最大限度避免企业内部敏感信息泄露。',
          ],
        },
      ],
      describeList3: [
        {
          type: 'text',
          title: '企业信息泄露追踪功能',
          col: 6,
          content: [
            '随着互联网社交媒体的发展，员工极易将企业内部信息泄漏到社交媒体中，进而可能导致信息被纂改、歪曲或放大或给企业声誉带来不良影响，亦或造成企业敏感信息泄露。',
            '企业信息泄露追踪功能可以快速帮助企业定位信息泄露源头并及时处置，进而减少相关损失。',
          ],
        },
        {
          type: 'image',
          src: require('@/assets/img/common/secure/describe3.png'),
          col: 6,
        },
      ],
      describeList4: [
         {
          type: 'image',
          src: require('@/assets/img/common/secure/describe4.png'),
          col: 6,
        },
        {
          type: 'text',
          title: '企业信息防截屏及日志记录功能',
          col: 6,
          content: [
            '员工在使用App过程中截取屏幕是导致企业敏感信息泄露的主要原因，为此App经过特殊设计，安卓系统下提供了信息防止截屏和拷贝功能，在IOS系统中提供了截屏日志功能。最大限度的减少企业信息泄露的可能。如果信息依然被泄露，企业管理人员可以通过后台截屏日志找到信息泄露的源头并进行处置。',
          ],
        },
       
      ],
      describeList5: [
        {
          type: 'text',
          title: '线边仓管理PDA',
          col: 7,
          content: [
            '线边仓主要服务产线，传统的ERP或MES不能覆盖线边仓的精细化物料管理需求。所以有必要开发一套线边仓管理系统，同时配合手持设备，方便仓库管理员快速对物料进行入库和出库操作。',
            '线边仓管理系统同时还提供了业务校验功能，以帮助仓库管理员校验出库物料是否符合产线要求。',
          ],
        },
        {
          type: 'image',
          src: require('@/assets/img/common/secure/describe5.png'),
          col: 5,
        },
      ],
    }
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>
<style scoped></style>
